<app-capture
  parentType="batch"
  [batchLoading]="batchLoading()"
  [batch]="batch"
  [batchDocuments]="batchDocuments"
  [enableBatchOptions]="enableBatchOptions()"
  (restartFilingEvent)="completeBatch()"
  (openEditBatchEvent)="openEditBatchModal()"
  (openAddDocumentsEvent)="openAddDocumentsModal($event)"
  (deleteBatchEvent)="confirmDeleteBatch()"
  (closeBatchEvent)="confirmCloseBatch()"
  (openScanningDialogEvent)="openScanningDialog($event)"
></app-capture>
<p-dialog
  class="add-documents-dialog"
  [header]="'addDocuments' | translate"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeAriaLabel]="'close' | translate"
  [(visible)]="showAddDocumentsModal"
  (onShow)="onDialogShow()"
>
  <div class="file-uploader-container">
    <app-file-uploader
      [tenantId]="tenantId"
      [hideScanning]="showAddDocumentsModal"
      (uploadedDocumentIdsEvent)="captureComponent.reopenAndAddDocuments($event)"
      (errorEvent)="captureComponent.handleDocumentUploadError($event)"
    >
    </app-file-uploader>
  </div>
</p-dialog>
<p-dialog
  class="edit-batch-dialog"
  [header]="'editBatch' | translate"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeAriaLabel]="'close' | translate"
  [(visible)]="showEditBatchModal"
>
  <div class="batch-info">
    <div class="batch-info-item">
      <span class="batch-info-item-label">{{ 'batchId' | translate }}</span>
      <span class="batch-info-item-text">{{ batch().batchId }}</span>
    </div>
    <div class="batch-info-item">
      <span class="batch-info-item-label">{{ 'creationDate' | translate }}</span>
      <span class="batch-info-item-text">{{ batch().createdAt | date: 'MM/dd/yyyy HH:mm a' }}</span>
    </div>
    <div class="batch-info-item">
      <span class="batch-info-item-label">{{ 'documentCount' | translate }}</span>
      <span class="batch-info-item-text">{{ batch().statistics?.documentCount }}</span>
    </div>
  </div>
  <hr class="modal-divider-line" />
  <div class="batch-settings">
    @if (showEditBatchModal) {
      <app-batch-settings
        departmentsPrivs="CHANGE_BATCH_ACCESS"
        [batchFormGroup]="editBatchFormGroup"
        [tenantId]="tenantId"
        [showBatchId]="false"
        [isEditing]="true"
      >
      </app-batch-settings>
    }
  </div>
  <div class="buttons-container">
    <p-button
      class="dap-cancel-batch cancel-button"
      severity="primary"
      variant="text"
      [label]="'cancel' | translate"
      [ariaLabel]="'cancel' | translate"
      (click)="closeEditBatchModal()"
    >
    </p-button>
    <p-button
      class="dap-save-batch save-button"
      [label]="'save' | translate"
      [ariaLabel]="'save' | translate"
      [disabled]="isBatchCompleted()"
      (click)="saveBatchSettings()"
    >
    </p-button>
  </div>
</p-dialog>
<app-web-scanning-dialog
  [(visible)]="showScanningDialog"
  (filesScanned)="onScannedFiles($event)"
>
</app-web-scanning-dialog>
